// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__27XeJ","footer":"ModalUpdate_footer__Hrr7h"};